import {useAnalytics, useReports} from '@sail/observability';
import {useMemo} from 'react';
import createIntlObject from 'src/public/useIntl/createIntlObject';
import useIntlConfig from 'src/public/useIntlConfig';

import type {IntlHook} from 'src/public/useIntl/types';

export default function useIntl(): IntlHook {
  const reports = useReports();
  const analytics = useAnalytics();
  const config = useIntlConfig();

  return useMemo<IntlHook>(
    () => createIntlObject(config, reports, analytics),
    [config, reports, analytics],
  );
}
